/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { ShiftPattern } from './ShiftPattern';
import {
    ShiftPatternFromJSON,
    ShiftPatternFromJSONTyped,
    ShiftPatternToJSON,
    ShiftPatternToJSONTyped,
} from './ShiftPattern';

/**
 * 
 * @export
 * @interface InspectionScheduleResponse
 */
export interface InspectionScheduleResponse {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    templateId?: string;
    /**
     * 
     */
    machineId?: string;
    /**
     * 
     */
    frequency?: InspectionScheduleResponseFrequencyEnum;
    /**
     * 
     */
    cronExpression?: string;
    /**
     * 
     */
    shiftPattern?: ShiftPattern;
    /**
     * 
     */
    startDate?: string;
    /**
     * 
     */
    endDate?: string;
    /**
     * 
     */
    active?: boolean;
    /**
     * 
     */
    lastGeneratedAt?: Date;
    /**
     * 
     */
    nextGenerationAt?: Date;
    /**
     * 
     */
    createdAt?: Date;
    /**
     * 
     */
    updatedAt?: Date;
}


/**
 * @export
 */
export const InspectionScheduleResponseFrequencyEnum = {
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    PerShift: 'PER_SHIFT',
    Custom: 'CUSTOM',
} as const;
export type InspectionScheduleResponseFrequencyEnum = typeof InspectionScheduleResponseFrequencyEnum[keyof typeof InspectionScheduleResponseFrequencyEnum];


/**
 * Check if a given object implements the InspectionScheduleResponse interface.
 */
export function instanceOfInspectionScheduleResponse(value: object): value is InspectionScheduleResponse {
    return true;
}

export function InspectionScheduleResponseFromJSON(json: any): InspectionScheduleResponse {
    return InspectionScheduleResponseFromJSONTyped(json, false);
}

export function InspectionScheduleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionScheduleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'frequency': json['frequency'] == null ? undefined : json['frequency'],
        'cronExpression': json['cronExpression'] == null ? undefined : json['cronExpression'],
        'shiftPattern': json['shiftPattern'] == null ? undefined : ShiftPatternFromJSON(json['shiftPattern']),
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'active': json['active'] == null ? undefined : json['active'],
        'lastGeneratedAt': json['lastGeneratedAt'] == null ? undefined : (parseDateTime(json['lastGeneratedAt'])),
        'nextGenerationAt': json['nextGenerationAt'] == null ? undefined : (parseDateTime(json['nextGenerationAt'])),
        'createdAt': json['createdAt'] == null ? undefined : (parseDateTime(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (parseDateTime(json['updatedAt'])),
    };
}

export function InspectionScheduleResponseToJSON(json: any): InspectionScheduleResponse {
    return InspectionScheduleResponseToJSONTyped(json, false);
}

export function InspectionScheduleResponseToJSONTyped(value?: InspectionScheduleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'templateId': value['templateId'],
        'machineId': value['machineId'],
        'frequency': value['frequency'],
        'cronExpression': value['cronExpression'],
        'shiftPattern': ShiftPatternToJSON(value['shiftPattern']),
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'active': value['active'],
        'lastGeneratedAt': value['lastGeneratedAt'] == null ? value['lastGeneratedAt'] : serializeDateTime(value['lastGeneratedAt']),
        'nextGenerationAt': value['nextGenerationAt'] == null ? value['nextGenerationAt'] : serializeDateTime(value['nextGenerationAt']),
        'createdAt': value['createdAt'] == null ? value['createdAt'] : serializeDateTime(value['createdAt']),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : serializeDateTime(value['updatedAt']),
    };
}

